module.exports = __webpack_public_path__ + "img/POSwhite.d5fc535e.png";